import { css } from "styled-components";

export const ProgressBarStyles = css(
    ({ theme: { palette } }) => css`
        .ProgressBar.ProgressBar {
            border-radius: 100px;
            background-color: ${palette.overlays[800][8]};
            height: 0.25rem;
        }

        .ProgressBarTrack.ProgressBarTrack {
            border-radius: 100px;
        }
    `,
);
